import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as actionType from "../../constants/actionTypes";
import * as userActions from "../../actions/index";
import Notification from "./Notification";
import { HeaderTime } from "./date";

const TopBar = (props) => {
    const [userInfo, setUserInfo] = useState(JSON.parse(localStorage.getItem("bss_authuser")));
    const accountMenuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (accountMenuRef.current && !accountMenuRef.current.contains(event.target)) {
                const menu = document.getElementById("topaccountmenu");
                const toggle = document.getElementById("topaccountmenudata");
                if (menu && toggle && menu.classList.contains("show")) {
                    toggle.click();
                }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        // Listen for storage changes to update avatar in real-time
        const handleStorageChange = () => {
            const updatedUserInfo = JSON.parse(localStorage.getItem("bss_authuser"));
            setUserInfo(updatedUserInfo);
        };

        // Add event listener for storage changes
        window.addEventListener("storage", handleStorageChange);

        // Poll localStorage every second to catch updates in the same tab
        const interval = setInterval(() => {
            const updatedUserInfo = JSON.parse(localStorage.getItem("bss_authuser"));
            if (JSON.stringify(updatedUserInfo) !== JSON.stringify(userInfo)) {
                setUserInfo(updatedUserInfo);
            }
        }, 1000);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            clearInterval(interval);
        };
    }, [userInfo]);

    useEffect(() => {
        // Fetch the latest school details so school name/logo/image stay in
        // sync for every logged-in user, not just the one who updated them.
        props.onGetCurrentUserProfile().then((response) => {
            if (response.success === true) {
                const school_data = response.data?.school;
                const user_data = response.data?.user;
                if (school_data || user_data) {
                    const updated_user_info = JSON.parse(localStorage.getItem("bss_authuser"));
                    if (school_data) {
                        updated_user_info.user_school = {
                            ...updated_user_info.user_school,
                            school_name: school_data.school_name,
                            school_logo: school_data.school_logo,
                        };
                        if (updated_user_info.school_name !== undefined) {
                            updated_user_info.school_name = school_data.school_name;
                        }
                    }
                    if (user_data) {
                        updated_user_info.first_name = user_data.first_name;
                        updated_user_info.last_name = user_data.last_name;
                        updated_user_info.email = user_data.email;
                        updated_user_info.avatar = user_data.avatar;
                    }
                    localStorage.setItem("bss_authuser", JSON.stringify(updated_user_info));
                    setUserInfo(updated_user_info);
                }
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const avatarUrl = userInfo?.avatar
        ? actionType?.environment_url + '/' + userInfo?.avatar 
        : "/assets/media/school-logo.png";

    return (
        <>
            <div id="kt_header" className="header align-items-stretch ">
                <div className="container-fluid d-flex align-items-stretch justify-content-between ">
                    <div className="d-flex align-items-center d-lg-none ms-n3 me-1 " title="Show aside menu">
                        <div className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px" id="kt_aside_mobile_toggle">
                            <span className="svg-icon svg-icon-2x mt-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="black" />
                                    <path
                                        opacity="0.3"
                                        d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                                        fill="black"
                                    />
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0 ktheaderbar">
                        <span className="d-lg-none">
                            <Link to="/dashboard">
                                <img alt="Logo" src="/assets/media/logos/logo.png" className="h-30px" />
                            </Link>
                        </span>
                    </div>

                    <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1 gettopbarmenu">
                        <div className="d-flex align-items-stretch" id="kt_header_nav">
                            <div
                                className="header-menu align-items-stretch"
                                data-kt-drawer="true"
                                data-kt-drawer-name="header-menu"
                                data-kt-drawer-activate="{default: false, lg: true}"
                                data-kt-drawer-overlay="true"
                                data-kt-drawer-width="{default:'200px', '300px': '250px'}"
                                data-kt-drawer-direction="end"
                                data-kt-drawer-toggle="#kt_header_menu_mobile_toggle"
                                data-kt-swapper="true"
                                data-kt-swapper-mode="prepend"
                                data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}"
                            >
                                <div
                                    className="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch"
                                    id="#kt_header_menu"
                                    data-kt-menu="true"
                                >
                                    <div className="menu-item me-lg-1 d-main-link">
                                        <h2 className="text-secondary ">
                                            {(userInfo?.school_name) ? userInfo?.school_name : userInfo?.user_school?.school_name}
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-items-stretch" id="kt_header_nav">
                            <div
                                className="header-menu align-items-stretch"
                                data-kt-drawer="true"
                                data-kt-drawer-name="header-menu"
                                data-kt-drawer-activate="{default: false, lg: true}"
                                data-kt-drawer-overlay="true"
                                data-kt-drawer-width="{default:'200px', '300px': '250px'}"
                                data-kt-drawer-direction="end"
                                data-kt-drawer-toggle="#kt_header_menu_mobile_toggle"
                                data-kt-swapper="true"
                                data-kt-swapper-mode="prepend"
                                data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}"
                            >
                                <div
                                    className="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch"
                                    id="#kt_header_menu"
                                    data-kt-menu="true"
                                >
                                    <div className="menu-item me-lg-1 d-main-link">
                                        <span className="text-secondary ">
                                            <HeaderTime/>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-items-stretch flex-shrink-0 ">
                            <div className="d-flex align-items-center px-5">
                                <Notification callNotification={props.callNotification} />
                            </div>
                            <div className="d-flex align-items-center" id="kt_header_user_menu_toggle">
                                <div className="d-flex fw-bold">
                                    {(userInfo?.role_type === 2) ? "Logged in as School Admin" : "Logged in as Manager"}
                                </div>
                            </div>

                            <div className="d-flex align-items-center ms-1 ms-lg-3">
                                <b>{userInfo?.first_name ? userInfo?.first_name + " " + userInfo?.last_name : "BSS"}</b>
                            </div>

                            <div className="d-flex align-items-center ms-1 ms-lg-3" id="kt_header_user_menu_toggle" ref={accountMenuRef}>
                                <div id="topaccountmenudata" className="cursor-pointer symbol symbol-30px symbol-md-40px topaccountmenudata " data-kt-menu-placement="bottom-end">
                                    <img alt="Logo" src={avatarUrl} key={avatarUrl} />
                                </div>
                                <div
                                    id="topaccountmenu"
                                    className="topaccountmenu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px profile-dropdown"
                                    data-kt-menu="true"
                                >
                                    <div className="menu-item px-3">
                                        <div className="menu-content d-flex align-items-center px-3">
                                            <div className="symbol symbol-50px me-5">
                                                <img alt="Logo" src={avatarUrl} key={avatarUrl} />
                                            </div>
                                            <div className="d-flex flex-column">
                                                <div className="fw-bolder d-flex align-items-center fs-5">
                                                    {userInfo?.first_name ? userInfo?.first_name + " " + userInfo?.last_name : "BSS"}
                                                </div>
                                                <span className="fw-bold text-muted text-hover-primary fs-7 email-info">
                                                    {userInfo?.email ? userInfo?.email : "bss@gmail.com"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="separator my-2"></div>
                                    <div className="menu-item px-5">
                                        <Link to="/account" className="menu-link px-5">
                                            My Account
                                        </Link>
                                    </div>
                                    <div className="menu-item px-5">
                                        <Link to="/logout" className="menu-link px-5">
                                            Sign Out
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapDispatchToProps = {
    onGetCurrentUserProfile: userActions.GetCurrentUserProfile,
};

export default connect(null, mapDispatchToProps)(TopBar);